<template>
	<div class="w-100">
		<Mobile v-if="window_width <= 768"></Mobile>
		<Desktop v-else></Desktop>
	</div>
</template>
<script>
	import Desktop from '@/pages/hotel/be/BeCartDesktop';
	import Mobile from '@/pages/hotel/be/BeCartMobile';
	export default{
		components:{
			Desktop,
			Mobile
		},
		data(){
			return{
				window_width: window.innerWidth
			}
		},
		mounted(){
			this.$postLog("CART","","First Load")
			this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
		},
		beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
		methods:{
			onResizeWindow(){
        this.window_width = window.innerWidth
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeCart.vue